import { useAppSelector } from 'shared/hooks/redux/hooks';
import { isIOSApp } from 'utils';
import { createSelector } from '@reduxjs/toolkit';
import { selectDevicesFields } from 'entities/device/lib';
import { isSocketDevice } from './is-socket';
const haveSockets03Device = createSelector(selectDevicesFields(['device_type', 'hardware_type']), (devices) => devices.some(isSocketDevice));
export const useShowBuyThermostatForSocket03 = () => {
    const is_demo = useAppSelector((state) => state.account.is_demo);
    const have_socket_device = useAppSelector(haveSockets03Device);
    return !is_demo && !isIOSApp() && have_socket_device;
};
